<script>
import _baseDropdownPicker from '../_base-dropdown-picker.vue'
import { getFileServerListApi } from '@/src/modules/patch-management/patch-management-api'

export default {
  name: 'FileServerPicker',
  extends: _baseDropdownPicker,
  props: {
    searchable: { type: Boolean, default: false },
  },
  data() {
    return {
      loadedFileServers: [],
    }
  },
  computed: {
    options() {
      return this.loadedFileServers
    },
  },
  created() {
    getFileServerListApi().then(({ items }) => {
      this.loadedFileServers = (items || []).map((t) => ({
        ...t,
        text: t.text || t.name,
        key: t.id,
      }))
    })
  },
}
</script>
